export default __webpack_public_path__ + "static/media/tele.aaf91cb6.svg";